import styled from 'styled-components';
import { colors } from 'global/colors';

export const Row = styled.div`
  width: 70vw;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 10px 0;
  align-items: center;
`;

export const InfoWrapper = styled.div``;

export const LabelHeading = styled.label`
  color: ${colors.darkGray};
  font-weight: 600;
  margin-bottom: 0px;
  font-size: 15px;
`;

export const LabelValue = styled.label`
  color: ${colors.lightGray2};
  margin-bottom: 0px;
  font-size: 14px;
`;
